export class ManageDiaryCommon {

  public static myDiaryFormErrors = {
    "amount": "",
    "approver" :  "",
    "assignment" :  "",
    "chargeableToClient" :  "",
    "client" :  "",
    "distanceFromOffice" :  "",
    "employee" : "",
    "entryDate" : "",
    "inTime" : "",
    "outTime" : "",
    "inTimeHour" : "",
    "inTimeMin" : "",
    "location" :  "",
    "mode" :  "",
    "outTimeHour" : "",
    "outTimeMin" : "",
    "rate" :  "",
    "task" : "",
    "travellingFrom" : "",
    "workPerformed" :  "",
    "noOfTimeHours":"",
    "noOfTimeMin":"",
    "extraTimeHours":"",
    "extraTimeMin":"",
    "debitedTimeHours":"",
    "debitedTimeMin":"",
    "creditedTimeHours":"",
    "creditedTimeMin":"",
    "assignmentForFY":"",
    "natureOfExpense":"",
  };

  public static myDiaryFormValidationMessages = {
    "amount": { 'required': 'mandatory field'},
    "approver" :  { 'required': 'mandatory field'},
    "assignment" :  { 'required': 'mandatory field'},
    "chargeableToClient" :  { 'required': 'mandatory field'},
    "client" :  { 'required': 'mandatory field'},
    "distanceFromOffice" :  { 'required': 'mandatory field','max': 'distance should be less than or equal to '},
    "employee" : { 'required': 'mandatory field'},
    "entryDate" : { 'required': 'mandatory field'},
    "inTime" : { 'required': 'mandatory field'},
    "outTime" : { 'required': 'mandatory field'},
    "inTimeHour" : { 'required': 'mandatory field'},
    "inTimeMin" : { 'required': 'mandatory field'},
    "location" :  { 'required': 'mandatory field'},
    "mode" :  { 'required': 'mandatory field'},
    "outTimeHour" : { 'required': 'mandatory field'},
    "outTimeMin" : { 'required': 'mandatory field'},
    "rate" :  { 'required': 'mandatory field'},
    "task" : { 'required': 'mandatory field'},
    "travellingFrom" : { 'required': 'mandatory field'},
    "workPerformed" :  { 'required': 'mandatory field'},
    "noOfTimeHours":{ 'required': 'mandatory field'},
    "noOfTimeMin":{ 'required': 'mandatory field'},
    "extraTimeHours":{ 'required': 'mandatory field'},
    "extraTimeMin":{ 'required': 'mandatory field'},
    "debitedTimeHours":{ 'required': 'mandatory field'},
    "debitedTimeMin":{ 'required': 'mandatory field'},
    "creditedTimeHours":{ 'required': 'mandatory field'},
    "creditedTimeMin":{ 'required': 'mandatory field'},
    "assignmentForFY":{ 'required': 'mandatory field'},
    "natureOfExpense":{ 'required': 'mandatory field'},
  };

}


